import Vue from 'vue'
import Vuex from 'vuex'

// include modules
import auth from './modules/auth'
import loyaltyProgram from './modules/loyaltyProgram'
import company from './modules/company'
import user from './modules/user'
import receipt from './modules/receipt'
import cartRewardItem from './modules/cartRewardItem'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    slug: '' || localStorage.getItem('slug')
  },
  mutations: {
    SET_SLUG ({ state }, slug) {
      this.state.slug = slug
    }
  },
  actions: {
    setSlug ({ commit }) {
      const slug = window.location.pathname.split('/')[2]
      localStorage.setItem('slug', slug)
      commit('SET_SLUG', slug)
    }
  },
  modules: {
    auth,
    loyaltyProgram,
    company,
    user,
    receipt,
    cartRewardItem
  }
})

export default store
